<template>
  <div class="test-data-holder">
    <div class="test-data-left">Disclaimer</div>
    <div class="test-data-right">
      These results are based on sprinkler tests in still air or low wind
      conditions and assume precise spacing, vertical sprinkler alignment,
      unchanging pressure, and uniform riser heights. Field factors that also
      affect uniformity of water application are: wind speed and direction,
      stream obstruction, sprinkler struts, slope, and pressure variation within
      an irrigated zone..
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintTestData',
};
</script>

<style scoped>
.test-data-holder {
  font-size: 12px;
  display: flex;
}
.test-data-left {
  font-weight: bold;
  padding-left: 15px;
  padding-right: 10px;
}
.test-data-right {
  padding-left: 10px;
  padding-right: 15px;
  flex: 1;
}
</style>
